import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render({ link, label, handleClick }) {
        return (
            <a className='pill' href={link} onClick={handleClick}>
                <span>{label}</span>
            </a>
        );
    }
}

export default connect()(Component);
